module.exports = __webpack_public_path__ + "img/IMG_6478.435423a6.jpg";